import React from 'react';

const Plot = ({ plotData }) => {
  return (
    <div className='w-full mt-6'>
      <img src={plotData} className='w-full rounded-md' alt="plot" />
    </div>
  );
};

export default Plot;
